import { makeStyles } from "tss-react/mui";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Theme,
} from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: "flex",
  },

  dialog: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
  },
}));

export interface ConfirmSavingGlobalLayoutDialogProps {
  open: boolean;
  handleConfirm: () => void;
  handleClose: () => void;
}

const ConfirmSavingGlobalLayoutDialogComponent: React.FC<
  ConfirmSavingGlobalLayoutDialogProps
> = ({ open, handleConfirm, handleClose }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className={classes.dialog}
      maxWidth={false}
    >
      <DialogTitle>{t("Confirm save to all entities")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("ConfirmLayoutSendToMesContent")}
        </DialogContentText>
        <DialogActions>
          <Button
            variant="contained"
            color="success"
            onClick={() => handleConfirm()}
          >
            {t("Submit")}
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => handleClose()}
          >
            {t("Cancel")}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmSavingGlobalLayoutDialogComponent;
